export default {
  namespaced: true,
  state: {
    validationModal: {
      isOpen: false,
      title: '',
      description: '',
      confirmLabel: '',
      onConfirm: null,
      onCancel: null,
      onClose: null,
      type: null,
      confirmBtn_Disabled: false,
      cancelBtn_Disabled: false,
      titleClass: null,
    },
    baseModal: {
      isOpen: false,
    },
  },
  getters: {
    isValidationModalOpen: state => state.validationModal.isOpen,
    validationModalConfig: state => state.validationModal,
    isModalOpen: state => state.baseModal.isOpen,
  },
  mutations: {
    OPEN_VALIDATION_MODAL(state, value) {
      const payload = value

      state.validationModal.isOpen = true
      state.validationModal.title = payload.title || ''
      state.validationModal.description = payload.description || ''
      state.validationModal.confirmLabel = payload.confirmLabel || ''
      state.validationModal.type = payload.type
      state.validationModal.confirmBtn_Disabled = payload.confirmBtn_Disabled || false
      state.validationModal.cancelBtn_Disabled = payload.cancelBtn_Disabled || false

      state.validationModal.onConfirm = payload.onConfirm
        ? () => {
          state.validationModal.isOpen = false

          setTimeout(() => {
            payload.onConfirm()
          }, 200)
        }
        : () => {
          state.validationModal.isOpen = false
        }

      state.validationModal.onCancel = state.validationModal.onCancel = payload.onCancel
        ? () => {
          payload.onCancel()

          state.validationModal.isOpen = false
        }
        : () => {
          state.validationModal.isOpen = false
        }

      state.validationModal.onClose = payload.onClose
        ? () => {
          state.validationModal.isOpen = false

          setTimeout(() => {
            payload.onClose()
          }, 200)
        }
        : () => {
          state.validationModal.isOpen = false
        }

      state.validationModal.titleClass = payload.titleClass
    },

    CLOSE_VALIDATION_MODAL(state) {
      state.validationModal.isOpen = false
      state.validationModal.title = ''
      state.validationModal.description = ''
      state.validationModal.confirmLabel = ''
      state.validationModal.type = null
      state.validationModal.onConfirm = null
      state.validationModal.onCancel = null
      state.validationModal.confirmBtn_Disabled = false
      state.validationModal.cancelBtn_Disabled = false
      state.validationModal.titleClass = null
    },
    OPEN_MODAL(state) {
      state.baseModal.isOpen = true
    },
    CLOSE_MODAL(state) {
      state.baseModal.isOpen = false
    },
  },
  actions: {},
}
